import PlainFieldset, { type FieldsetProps } from './plain-fieldset'


export default PlainFieldset
export type { FieldsetProps }
